module.exports = __webpack_public_path__ + "static/9-4a75f5e41c797edca302ba036b69b2d6.jpg";